"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledForm = exports.FullWidthButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const themed_button_1 = require("../themed-button");
exports.FullWidthButton = (0, styled_components_1.default)(themed_button_1.ThemedButton) `
  width: 100%;
  border-radius: 8px;
  height: 45px;
  line-height: 16px;
  font-size: 16px;
`;
exports.StyledForm = styled_components_1.default.form `
  margin: ${(props) => props.theme.spacings.small} 0 0 0;
`;
